import { Globe } from 'lucide-react';
import { ReactNode } from 'react';
import type { ScopeSection } from 'v5/core/entity-schema/entitySchema.types';
import { cn } from 'v5/platform/dom/cn';
import { EnterpriseWorkspaceIcon } from './EnterpriseWorkspaceIcon';

export type WorkspaceIconLookup = ReadonlyMap<
  number,
  { name: string; iconUrl: string }
>;

/**
 * Icon for a schema-form scope section: a globe for Global, the workspace
 * icon for a workspace section. Shared by every entity form with
 * per-workspace sections (resources today, productions / bookings next).
 */
export function createScopeSectionIconRenderer(
  workspaceIcons: WorkspaceIconLookup
): (section: ScopeSection) => ReactNode {
  return section => {
    if (section.scope.type === 'global') {
      return <Globe className="size-5 shrink-0 text-fg-muted" />;
    }
    const workspace = workspaceIcons.get(section.scope.workspaceId);
    // One step above the globe: a square icon (or its padding) reads smaller
    // than the globe's outline at the same size. Initials get a darker box,
    // as the default subtle one disappears on the grey tab strip.
    return workspace ? (
      <EnterpriseWorkspaceIcon
        name={workspace.name}
        iconUrl={workspace.iconUrl}
        className={cn(
          '-my-0.5 size-6 text-xs',
          !workspace.iconUrl && 'bg-bg-inset'
        )}
      />
    ) : null;
  };
}
